<script lang="ts">
  import Button from '$src/js/components/molecules/button/Button.svelte';
  import BaseModule from '$src/js/modules/base/BaseModule';
  import { VoteState } from '$src/js/states/VoteState.svelte';
</script>

<div class="relative">
  <div class="relative z-2 mx-auto max-w-[1200px] px-4 pt-20 md:pt-45">
    <h2
      class="font-clorat text-yellow mb-4 text-[24px] leading-[100%] sm:mb-6 sm:text-[32px] lg:text-[40px]"
    >
      {BaseModule.getInstance().i18n.translate('story_subtitle')}
    </h2>

    <h1
      class="font-clorat text-yellow mb-6 text-[56px] leading-[80%] sm:mb-8 sm:text-[96px] lg:text-[160px]"
    >
      {BaseModule.getInstance().i18n.translate('story_title')}
    </h1>

    <p class="mb-12 text-[16px] leading-[180%] font-light sm:mb-16 sm:text-[20px] lg:text-[24px]">
      {BaseModule.getInstance().i18n.translate('story_text_line1')}
      <br />
      {BaseModule.getInstance().i18n.translate('story_text_line2')}
      <br />
      {BaseModule.getInstance().i18n.translate('story_text_line3')}
    </p>

    <!-- Enable after voting phase -->
    <!-- <LimitedOffer /> -->

    {#if !VoteState.votingEnded}
      <Button
        size="medium"
        text={BaseModule.getInstance().i18n.translate('cta_button')}
        type="button"
        onclick={() => BaseModule.getInstance().scroll.scrollToVote()}
      />
    {/if}
  </div>

  <img
    class="mx-auto mt-10 w-[1400px] max-sm:hidden md:-mt-[6svw] lg:-mt-[160px]"
    src="https://yellow-b-global.b-cdn.net/production/the-architect/images/background.jpg"
    alt="background"
  />
  <img
    class="mx-auto mt-10 w-[1400px] sm:hidden md:-mt-[6svw] lg:-mt-[160px]"
    src="https://yellow-b-global.b-cdn.net/production/the-architect/images/background-mobile.jpg"
    alt="background"
  />
</div>
